import Step from 'semantic-ui-react/dist/commonjs/elements/Step';
import '@purple/semantic-ui-purple-theme/components/step.css';

export default Step;
